"use client";

import { GoogleOneTap, SignUp } from "@clerk/nextjs";
import { useTheme } from "next-themes";
import { dark } from "@clerk/themes";

export default function SignupPage() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  return (
    <>
      <GoogleOneTap
        appearance={{
          baseTheme: isDark ? dark : undefined,
        }}
      />
      <SignUp
        appearance={{
          baseTheme: isDark ? dark : undefined,
        }}
        signInUrl="/sign-in"
      />
    </>
  );
}
